import React, { Fragment } from "react";
import EmailNotificationsListTable from "./EmailNotificationsListTable";
import { useTranslation } from "react-i18next";
import { Box, Grid } from "@mui/material";
import { AlertSpg, GridSpg, TableSkeleton } from "@duosoftbg/nacid-components";
import DeleteEmailNotificationDialog from "./dialog/DeleteEmailNotificationDialog";
import ResendEmailNotificationDialog from "./dialog/ResendEmailNotificationDialog";
import ViewEmailNotificationDialog from "./dialog/ViewEmailNotificationDialog";

const EmailNotificationsList = ({ records, total, isLoading, onPageOrOrderChange, blockTable, group, filterFn }) => {
  const { t } = useTranslation();

  const showTable = () => {
    if (!(total > 0)) {
      return (
        <AlertSpg mt={10} severity="info">
          {t("m.empty.list")}
        </AlertSpg>
      );
    }
    return (
      <Fragment>
        <DeleteEmailNotificationDialog filterFn={filterFn} records={records} total={total} />
        <ResendEmailNotificationDialog filterFn={filterFn} />
        <ViewEmailNotificationDialog />
        <EmailNotificationsListTable
          records={records}
          total={total}
          onPageOrOrderChange={onPageOrOrderChange}
          blockTable={blockTable}
          group={group}
        />
      </Fragment>
    );
  };

  return (
    <Box>
      <Grid container spacing={1}>
        <GridSpg item xs={12}>
          {isLoading ? <TableSkeleton /> : showTable()}
        </GridSpg>
      </Grid>
    </Box>
  );
};

export default EmailNotificationsList;
